module.exports = __webpack_public_path__ + "img/logo-white.4ab1b374.png";